// German localisations
export const de = {
    home: {
        'welcome-message': 'Herzlich Willkommen bei {name}',
        'select-performance': 'Bitte wählen Sie eine Aufführung:',
        'back-to-login': 'Zurück zur Anmeldung',
        'loading-performances': 'Aufführungen werden geladen...',
        'no-performances-available': 'Keine Aufführungen verfügbar',
        'refresh': 'Aktualisieren'
    },
    performance: {
        'not-started': 'Die Aufführung hat noch nicht begonnen.',
        'show-previous': 'Vorherige zeigen',
        'back-to-new': 'Zurück zur Liveansicht'
    },
    settings: {
        'title': 'Einstellungen',
        'profile': 'Profil/Sprache',
        'show-time': 'Empfangszeit anzeigen',
        'show-media': 'Medien anzeigen',
        'large-text': 'Große Schrift verwenden',
        'new-on-top': 'Neue Übertitel oben anzeigen',
        'display-style': 'Darstellungsstil',
        'display-inline': 'Alle Übertitel immer anzeigen',
        'display-sticky': 'Neuste Zusammenfassung immer anzeigen',
        'analytics': 'Nutzungsdaten',
        'data-warning': 'Bei Zustimmung werden Ihre Nutzungsdaten übertragen',
        'wakelock': 'Gerät aktiv halten',
        'text-size' : 'Schriftgröße',
        'sample-text' : 'Beispieltext für  die Schriftgröße der Übertitel',
    },
    about: {
        'cosy': 'Cooperative Systems',
        'faculty': 'Fakultät für Informatik',
        'uni': 'Universität Wien',
        'addr1': 'Währinger Straße 29/S6',
        'addr2': 'A-1090 Wien',
        'copyright': '© 2021 Cooperative Systems (COSY) Universität Wien'
    },
    login: {
        'input-label': 'Bitte Pin eingeben',
        'go-button': 'Vorstellung finden',
        'incorrect-pin': 'Ungültiger Pin'
    },
    hostlist: {
        'loading': 'Aufführungen werden geladen...',
        'no-hosts-available': 'Keine Veranstaltungsorte verfügbar',
        'welcome-message': 'Herzlich Willkommen zu opera.guru',
        'select-host': 'Wählen Sie bitte einen Veranstaltungsort:'
    }
};
